import React from 'react';
import {
    TouchableOpacity,
    View,
    Text,
    StyleSheet,
    // Modal,
    ActivityIndicator,
    ScrollView,
    ImageBackground
} from "react-native";

import Modal from './base/Modal';

// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import Config from '../../constants/Config';

import { useNavigation } from '@react-navigation/native';
import { Currency } from '../../constants/Utils';
import { AuthContext } from '../../contexts/auth/Store';
import { OrderContext } from '../../contexts/order/Store';
import { AnalyticsService } from '../../constants/Analytics';
import Colors from '../../constants/Colors'
import FontStyles from '../../constants/FontStyle';
import StyledButton from '../StyledButton';
import http from '../../utils/http';
import { formatCurrency } from '../../utils/money';

const analytics = new AnalyticsService();

const EditCartCountModal = ({ isActive, hideModal, item, order, updateOrder }) => {
    const navigation = useNavigation();

    const authContext = React.useContext(AuthContext);
    const token = authContext.getUserData.userToken;
    const buyer = authContext.getUserData.buyerData;

    const { action: order_fetch } = React.useContext(OrderContext);

    const [oldItem, setOldItem] = React.useState(item)
    const [isSubmitting, setSubmitting] = React.useState(false);
    const [orderQty, setOrderQty] = React.useState('0')
    const [unitPrice, setUnitPrice] = React.useState(0)
    const [price, setPrice] = React.useState(0)
    const [minState, setMinState] = React.useState(false)

    const clickAreaRef = React.useRef()

    React.useEffect(() => {
        if (item && item.quantity) {
            if (item.quantity > item?.product?.pricetag?.mpu) {
                setMinState(false)
            } else {
                setMinState(true)
            }
            setOrderQty(item.quantity.toString())
            setUnitPrice(item.product.pricetag.price / item.product.pricetag.mpu)
            setOldItem(Object.assign({}, item))
        }
        return () => {
        }
    }, [item])

    React.useEffect(() => {
        if (item?.product && orderQty > item?.product?.pricetag?.mpu) {
            setMinState(false)
        }
        else {
            setMinState(true)
        }
        setPrice(unitPrice * orderQty.toString())
        return () => {
        }
    }, [orderQty])

    const increaseQty = () => {
        setMinState(false)
        let value = parseInt(orderQty)
        value += item.product.pricetag.mpu
        setOrderQty(value.toString())
    }
    const decreaseQty = () => {
        let value = parseInt(orderQty)
        if (value <= item.product.pricetag.mpu) { return }
        value -= item.product.pricetag.mpu
        if (value < item.product.pricetag.mpu) {
            setMinState(true)
            return
        }
        setOrderQty(value.toString())
    }

    const updateCart = (item) => {

        let new_amount = order.amount - oldItem.amount + price

        setSubmitting(true)

        let form = new FormData()
        form.append("_id", item._id)
        form.append("quantity", orderQty)
        form.append("amount", price)
        form.append("product_id", item.product_id)
        form.append("order_id", item.order_id)

        let form_2 = new FormData()
        form_2.append('_id', order._id)
        form_2.append('ref', order.ref)
        form_2.append('payment', order.payment)
        form_2.append('tag', order.tag)
        form_2.append('meta', order.meta)
        form_2.append('amount', new_amount)
        form_2.append('manufacturer_id', order.manufacturer_id)
        form_2.append('seller_id', order.seller_id)
        form_2.append('buyer_id', order.buyer_id)
        form_2.append('sales_officer_id', order.sales_officer_id)

        let req_item = http.post('order_item/update', form, token)
        let req_order = http.post('order/update', form_2, token)

        Promise.all([req_item, req_order]).then(([res_item, res_order]) => {
            setSubmitting(false)
            hideModal()
            try {
                if (res_item.code === 200 || res_order.code === 200) {
                    order_fetch().then(res => { }).catch(e => { console.log(e) })
                    analytics.logEvent('Updated Order Item', buyer, {
                        order_item_id: item._id,
                        product_name: item.product.name
                    })
                    updateOrder('UPDATE', new_amount, item._id)
                } else {
                    console.log('update order item error:', res_item, res_order)
                }
            } catch (e) {
                console.log(e)
            }
        }).catch(err => {
            setSubmitting(false)
            console.log(err)
        })

    }

    const handleClickOutside = e => {
        e.persist()
        if (clickAreaRef.current) {
            if (e.target === clickAreaRef.current._nativeTag) {
                if (!isSubmitting) {
                    hideModal()
                }
            }
        }
    }

    const ExitButton = () => {
        return <TouchableOpacity
            style={styles.exitButton}
            onPress={() => {
                hideModal()
            }} >
            <Icon name='md-close' size={24} color='#000000A0' />
        </TouchableOpacity>
    }

    return (
        <Modal
            presentationStyle='overFullScreen'
            animationType="slide"
            transparent={true}
            visible={isActive}
            onRequestClose={() => {
                hideModal()
            }}>
            <View
                ref={clickAreaRef}
                onStartShouldSetResponder={handleClickOutside}
                style={[styles.overlay, { justifyContent: isSubmitting ? 'center' : 'flex-end' }]}
            >
                {isSubmitting
                    ? <ActivityIndicator size={36} color="white" style={{ alignSelf: 'center' }} />
                    : <View style={[styles.container, { justifyContent: isSubmitting ? 'center' : 'flex-end' }]}>
                        <View style={[styles.scrollWrapper]}>
                            <ExitButton />
                            <ScrollView contentContainerStyle={styles.scrollCard}>

                                <View style={[styles.imageWrapper, { paddingVertical: item?.product.pricetag.mpu === item?.product.case_count && item?.product.pricetag.mpu === 1 ? undefined : 9 }]}>
                                    {item?.product.upload && <ImageBackground
                                        source={{ uri: `${Config.uploadUrl}${item?.product.upload.path}` }}
                                        style={[styles.image]}
                                        resizeMode="contain">
                                    </ImageBackground>}
                                </View>

                                <Text style={[styles.cardBody, styles.cardHeader, { textAlign: 'center' }]}>{item.product.name}</Text>
                                <Text style={[styles.cardBody, styles.cardSubHeader]}>{item.product.case_count} {item.product.pricetag.mpu === item.product.case_count && item.product.pricetag.mpu === 1 ? item.product?.tags?.HIGHER_UNIT?.value : item.product?.tags?.LOWER_UNIT?.value + 's/' + item.product?.tags?.HIGHER_UNIT?.value} ({formatCurrency(item.product.case_count * unitPrice)})</Text>

                                <View style={styles.counterWrapper}>
                                    {minState && <TouchableOpacity disabled={true} style={[styles.counterBtn, { backgroundColor: '#3B54EC6A' }]}>
                                        <Icon name="md-remove" size={24} color='#FFFFFF' />
                                    </TouchableOpacity>}
                                    {!minState && <TouchableOpacity onPress={decreaseQty} style={styles.counterBtn}>
                                        <Icon name="md-remove" size={24} color='#FFFFFF' />
                                    </TouchableOpacity>}
                                    <Text style={styles.counterInput}>{orderQty}</Text>
                                    <TouchableOpacity onPress={increaseQty} style={styles.counterBtn}>
                                        <Icon name="md-add" size={24} color='#FFFFFF' />
                                    </TouchableOpacity>
                                </View>
                                <Text style={styles.quantityText}>Quantity ({orderQty} {item?.product?.pricetag.mpu === item?.product?.case_count && item?.product?.pricetag.mpu === 1 ? `${item?.product?.tags?.HIGHER_UNIT?.value}${orderQty > 1 ? 's' : ''}` : item?.product?.tags?.LOWER_UNIT?.value + 's'})</Text>
                                {
                                    // promoQty && <Text style={{ color: 'red' }}>Promo: {orderQty + promoQty} pcs</Text>
                                }
                                <Text style={styles.priceText}>{formatCurrency(price)}</Text>

                            </ScrollView>
                            <StyledButton
                                label="Update"
                                submitting={isSubmitting}
                                disabled={isSubmitting}
                                action={() => updateCart(item)}
                            />
                        </View>
                    </View>
                }
            </View>
        </Modal>
    )
}

export default EditCartCountModal

const styles = StyleSheet.create({
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.6)',
        flex: 1,
        alignItems: 'center'
    },
    imageWrapper: {
        width: '100%',
        backgroundColor: Colors.whiteColor,
        borderBottomColor: Colors.borderColor,
        borderBottomWidth: 1,
        borderStyle: 'solid',
    },
    image: {
        width: '100%',
        height: 170,
    },
    container: {
        flex: 1,
        width: '100%',
    },
    exitButton: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        position: 'absolute',
        top: 16,
        right: 16,
        zIndex: 2,
        width: 40,
        height: 40,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 20,
        backgroundColor: 'rgba(250,250,250,0.4)'
    },
    exitButtonText: {
        color: Colors.whiteColor,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
        marginRight: 8,
    },
    card: {
        borderTopLeftRadius: 25,
        borderTopRightRadius: 25,
        backgroundColor: Colors.whiteColor,
        paddingHorizontal: 20,
        paddingBottom: 16,
    },
    scrollWrapper: {
        borderTopLeftRadius: 25,
        borderTopRightRadius: 25,
        justifyContent: 'flex-end',
        marginTop: 50,
        overflow: 'hidden',
    },
    scrollCard: {
        backgroundColor: Colors.whiteColor,
        alignItems: 'center',
        paddingBottom: 34,
        justifyContent: 'flex-end',
        backgroundColor: '#f7f8f9'
    },
    cardHeader: {
        marginTop: 20,
        color: '#070B1F',
        ...FontStyles.size16,
        ...FontStyles.lh22,
        ...FontStyles.bold,
        textAlign: 'center',
    },
    cardSubHeader: {
        marginTop: 6,
        color: Colors.shades._7,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.normal,
        textAlign: 'center',
    },
    cardBody: {
        width: 288,
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.normal,
    },
    counterWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        paddingVertical: 4,
        paddingHorizontal: 6,
        borderColor: '#3B54EC0D',
        backgroundColor: '#3B54EC1A',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 20,
        marginTop: 32,
    },
    counterBtn: {
        width: 34,
        height: 34,
        borderRadius: 17,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#3B54EC',
        color: '#FFFFFF'
    },
    counterInput: {
        color: '#070B1F',
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: 22,
        paddingVertical: 0,
        marginHorizontal: 20,
        textAlign: "center"
    },
    priceText: {
        ...FontStyles.dark,
        ...FontStyles.size22,
        ...FontStyles.lh26,
        ...FontStyles.bold,
        marginTop: 16,
    },
    quantityText: {
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.normal,
        marginTop: 7,
    }
})